export const SECTION_HERO_I18N_JA = {
    title: "人気の検索",
    tagsAriaLabel: "人気検索ワード一覧",
    adLabel: "広告",
    adText: "広告",
    searchBaseUrl: "/home/ja/index.php?q=",
    popularKeywordsApiUrl: "/api/home/ja/popular-keywords.php",
    popularKeywordClickApiUrl: "/api/home/ja/popular-keywords-click.php",
};
